import './QuestionImagesRow.sass';

import ModalImage from 'react-modal-image';

import UploadInput from '../../UploadInput/UploadInput';
import { QuestionExtraInformation } from './QuestionExtraInformation';

const ANSWER_LABELS = ['A', 'B', 'C', 'D'];

export const IMAGE_SLOT_KEYS = {
  QUESTION: 'question',
  ANSWER: (label) => `answer-${label}`,
};

const SINGLE_SLOT_TITLES = {
  question: 'Question Image',
  'answer-A': 'Answer Image',
  'answer-B': 'Answer Image',
  'answer-C': 'Answer Image',
  'answer-D': 'Answer Image',
};

export function QuestionImagesRow({
  question,
  isCreatingAiQuestion,
  editPermission,
  onUpdateQuestionImage,
  onDeleteQuestionImage,
  onUpdateAnswerImage,
  onDeleteAnswerImage,
  visibleSlot,
}) {
  const hasAnyImage = Boolean(
    question?.imageUrl || question?.answers?.some((answer) => answer?.imageUrl),
  );

  // Mutually exclusive with audio: hide the whole row while audio exists,
  // unless a slot already has an image (lets it be removed).
  if (question?.audio && !hasAnyImage) {
    return null;
  }

  const backgroundColor = isCreatingAiQuestion ? '#d9d0fa' : '#e4ecf9';
  const headerColor = isCreatingAiQuestion ? '#b8a6f0' : '#afc8f0';

  const allSlots = [
    {
      key: 'question',
      label: 'Question',
      imageUrl: question?.imageUrl,
      onUpdate: onUpdateQuestionImage,
      onDelete: onDeleteQuestionImage,
    },
    ...ANSWER_LABELS.map((label, index) => ({
      key: `answer-${label}`,
      label: `Answer ${label}`,
      imageUrl: question?.answers?.[index]?.imageUrl,
      onUpdate: (chapter) => onUpdateAnswerImage(index, chapter),
      onDelete: () => onDeleteAnswerImage(index),
    })),
  ];

  const slots = visibleSlot
    ? allSlots.filter((slot) => slot.key === visibleSlot)
    : allSlots;

  if (slots.length === 0) {
    return null;
  }

  const hasImages = slots.some((slot) => slot.imageUrl);
  const title = visibleSlot ? SINGLE_SLOT_TITLES[visibleSlot] : 'Images';

  return (
    <QuestionExtraInformation
      title={title}
      backgroundColor={backgroundColor}
      headerColor={headerColor}
      body={
        <div className={`imagesRow${hasImages ? ' hasImages' : ''}`}>
          {slots.map((slot) => (
            <div className="imageSlot" key={slot.key}>
              <div className="imageSlotContent">
                <UploadInput
                  editPermission={editPermission}
                  imageUrl={slot.imageUrl}
                  accept="image/x-png,image/gif,image/jpeg,image/jpg,image/webp"
                  chapter={{ id: slot.key }}
                  maxFileSize={500 * 1024} // 500KB limit for images
                  deletePdfChapter={slot.onDelete}
                  updateQuestionPdfProcessing={() => {}}
                  questionPdfProcessing={false}
                  updateChapter={slot.onUpdate}
                  className="questionImageUrl text imageSlotUpload"
                />
                {slot.imageUrl?.includes('http') && (
                  <div
                    onClick={(e) => e.stopPropagation()}
                    className="image-question-preview-container"
                  >
                    <ModalImage
                      // Every upload gets a brand new S3 key (see Upload.urlBase
                      // in the API), so the URL is already unique per image -
                      // no cache-busting query param needed, and adding one
                      // recomputed on every render would force a re-fetch on
                      // every keystroke elsewhere in the form.
                      small={slot.imageUrl}
                      large={slot.imageUrl}
                      alt={slot.label}
                      className="image-question-preview"
                      hideDownload
                      hideZoom
                    />
                  </div>
                )}
              </div>
              {!visibleSlot && (
                <span className="imageSlotLabel">{slot.label}</span>
              )}
            </div>
          ))}
        </div>
      }
    />
  );
}
